import { cn } from "@newxsystems/shared";
import type { IVelvetSectionProps } from "./VelvetSection.props";

export const VelvetSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IVelvetSectionProps) => (
  <section
    className={cn("velvet-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("velvet-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

VelvetSection.displayName = "Content::VelvetSection";
